export const candidateSelection = {
  "candidateSelection.candidates.get": "candidateSelection.candidates.get",
  "candidateSelection.documents.get": "candidateSelection.documents.get",
  "candidateSelection.documents.download":
    "candidateSelection.documents.download",
  "candidateSelection.status.update": "candidateSelection.status.update",
  "candidateSelection.audit.upload": "candidateSelection.audit.upload",
  "candidateSelection.audit.status.update":
    "candidateSelection.audit.status.update",
} as const;
